const Status = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

export default (state = {info: [], mail: [], node: [], errorMsg: '', checkSchedule: 0}, action) => {
  switch(action.type) {
    case 'USER/INFO_STARTED': {
      return {...state, infoStatus: Status.LOADING}
    }
    case 'USER/INFO_SUCCESS': {
      const result = action.result
      return {...state, infoStatus: Status.SUCCESS, info: result}
    }
    case 'USER/INFO_FAILURE': {
      return {...state, infoStatus: Status.FAILURE}
    }
    case 'USER/MAIL_STARTED': {
      return {...state}
    }
    case 'USER/MAIL_SUCCESS': {
      const result = action.result
      return {...state, mail: result}
    }
    case 'USER/MAIL_FAILURE': {
      return {...state}
    }
    case 'USER/NODE_STARTED': {
      return {...state, nodeStatus: Status.LOADING}
    }
    case 'USER/NODE_SUCCESS': {
      const result = (action.result === null) ? [] : action.result
      return {...state, nodeStatus: Status.SUCCESS, node: result}
    }
    case 'USER/NODE_FAILURE': {
      return {...state, nodeStatus: Status.FAILURE}
    }
    case 'USER/REALNAME_STARTED': {
      return {...state}
    }
    case 'USER/REALNAME_SUCCESS': {
      const result = action.result
      return {...state, realName: result}
    }
    case 'USER/REALNAME_FAILURE': {
      return {...state}
    }
    case 'USER/CHANGENODE_SUCCESS': {
      const result = action.result
      if(!result.errorcode && state.node.length === 0) {
        state.node = [{
          "fog_ip": result.configs[0].server,
          "fog_port": result.configs[0].server_port,
          "fog_password": result.configs[0].password
        }] 
        return {...state}
      }
      if(!result.errorcode) {
        state.node[0].fog_ip = result.configs[0].server
        state.node[0].fog_port = result.configs[0].server_port
        state.node[0].fog_password = result.configs[0].password
        return {...state}
      } else {
        return {...state, errorMsg: result.errormsg}
      }
    }
    case 'USER/CHECKSCHEDULE_SUCCESS': {
      const result = action.result.flag
      return {...state, checkSchedule: result}
    }
    case 'USER/CHANGESCHEDULE_STARTED': {
      return {...state, changeStatus: Status.LOADING}
    }
    case 'USER/CHANGESCHEDULE_SUCCESS': {
      state.info[0].schedule_type = action.data
      return {...state, changeStatus: Status.SUCCESS}
    }
    case 'USER/CHANGESCHEDULE_FAILURE': {
      return {...state, changeStatus: Status.FAILURE}
    }
    case 'SHOW_MODAL': {
      return {...state, modalShow: true}
    }
    case 'HIDE_MODAL': {
      return {...state, modalShow: false};
    }
    default: {
      return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/user/reducer.js